import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Container } from 'react-bootstrap';
import Introduce from '../../components/Dashboard/Introduce';
import '../../../src/_metronic/_assets/sass/custom/_dashborad.scss';
import { organizationDemandList } from '../store/action/organization';
import { instructorDemandList } from '../store/action/instructor';
import Toast from '../../components/Toast';
import {
  getDashboardCreateOptions,
  getDashboardListOptions,
  isUserDenyInstructorInAnyOrg,
  isUserInstructorInAnyOrg,
  isUserPendingInstructorInAnyOrg,
} from '../../utils/PermissionManager';
import { permissionTypes } from '../../utils';
import Select from 'react-select';

const Dashboard = ({ history }) => {
  let listOfOrganizationDemands = useSelector(state => state.organization.demand.list);
  let listOfInstructorDemands = useSelector(state => state.instructor.demand.list);

  const { permissions, selectedRole, selectedOrg } = useSelector(state => state.permission);

  let dispatch = useDispatch();

  useEffect(() => {
    dispatch(organizationDemandList());
    dispatch(instructorDemandList());
    // eslint-disable-next-line
  }, []);

  function createCourse() {
    if (selectedRole == null) {
      return Toast(
        'شما دسترسی درخواست ساخت دوره رو ندارید برای ایجاد دوره ابتدا باید حداقل عضو یک سازمان باشید.',
        'error'
      );
    }
    if (selectedRole?.name === permissionTypes.instructor) {
      if (
        listOfInstructorDemands.data.length > 0 &&
        listOfInstructorDemands.data?.map(item => item.status).includes(2)
      ) {
        return history.push('/courses/new');
      } else {
        return Toast(
          'شما دسترسی درخواست ساخت دوره رو ندارید برای ایجاد دوره ابتدا باید حداقل عضو یک سازمان باشید.',
          'error'
        );
      }
    } else {
      return history.push('/courses/new');
    }
  }

  function homeInstructorButtonClick(listOfInstructorDemands) {
    if (listOfInstructorDemands.data.length === 0) {
      history.push('/instructor/new');
    } else {
      if (isUserInstructorInAnyOrg(listOfInstructorDemands)) {
        history.push('/me', { replace: true });
      } else if (isUserPendingInstructorInAnyOrg(listOfInstructorDemands)) {
        return Toast('شما یک درخواست درحال بررسی دارید', 'warning');
      } else if (isUserDenyInstructorInAnyOrg(listOfInstructorDemands)) {
        return Toast('درخواست شما قبلا بررسی و رد شده است', 'error');
      }
    }
  }

  function createOrg() {
    //accepted
    if (listOfOrganizationDemands.data.map(item => item.status).includes(2)) {
      return Toast('شما یک سازمان فعال دارید و اجازه ساخت سازمان جدید ندارید.', 'error');
      //pending
    } else if (listOfOrganizationDemands.data.map(item => item.status).includes(1)) {
      return Toast('شما یک درخواست ساخت سازمان دارید و اجازه درخواست جدید ندارید.', 'error');
    } else {
      return history.push('/orgs/new');
    }
  }

  return (
    <>
      <div className="kt-portlet p-3">
        <div className="kt-portlet__body pt-0">
          <div style={{ width: '100%', margin: 'auto' }}>
            <Container>
              <Col xs={12}>
                <Introduce />
                {getDashboardCreateOptions(
                  selectedOrg,
                  selectedRole,
                  createCourse,
                  createOrg,
                  () => homeInstructorButtonClick(listOfInstructorDemands),
                  permissions,
                  listOfInstructorDemands
                )}
              </Col>
              {getDashboardListOptions(selectedRole, listOfOrganizationDemands, listOfInstructorDemands)}
            </Container>
          </div>
        </div>
      </div>
    </>
  );
};

// table thead for all requests table
const thead = ['#', 'نوع', 'وضعیت'];

export default Dashboard;
